export function buildSearchCondition(serviceConfig, keyword: string) {
  const separator = serviceConfig.separator ?? " ";
  const tokens = keyword.trim().replace(/\s{2,}/g, " ").split(separator);
  const condition: any = { type: "OR", items: [] };

  if (serviceConfig.resultField === "person" && tokens.length === 2) {
    const [first, second] = tokens;
    const conditions1 = [
      { type: "COND", field: "Person.firstName", op: "LIKE", param: `%${first}%` },
      { type: "COND", field: "Person.lastName", op: "LIKE", param: `%${second}%` },
    ];
    const conditions2 = [
      { type: "COND", field: "Person.lastName", op: "LIKE", param: `%${first}%` },
      { type: "COND", field: "Person.firstName", op: "LIKE", param: `%${second}%` },
    ];
    condition.items.push({ type: "AND", items: conditions1 });
    condition.items.push({ type: "AND", items: conditions2 });
  } else {
    for (const token of tokens) {
      for (const field of serviceConfig.fields) {
        condition.items.push({ type: "COND", field, op: "LIKE", param: `%${token}%` });
        condition.items.push({ type: "COND", field, op: "LIKE", param: `${token}%` });
      }
    }
  }

  return {
    type: "AND",
    items: [
      {
        type: "OR",
        items: condition.items
      }
    ]
  };
}